module.exports = __webpack_public_path__ + "img/octagon.8c3cbbca.svg";